import { FC, useContext, useState } from "react";
import RenderNextStep from "src/pages/dashboard/caseItemActions";

import { TreatmentStatusProps } from "./types";
import TransferCaseModal from "src/components/modals/transferCaseDialogs/transferCaseModal";
import TransferNotNowModal from "src/components/modals/transferCaseDialogs/transferNotNowModal";
import UploadClinicalModal from "src/components/modals/transferCaseDialogs/uploadClinicalModal";
import { AuthContext } from "src/context/authContext";
import { useLocation, useNavigate } from "react-router-dom";
import { handleNavigation } from "src/helpers";




const TreatmentStatus: FC<TreatmentStatusProps> = ({ refreshAPICall, setDataForCancelModal, showHideModalForTreatment, case_id, prescription_id, investigated_at,active_precert_id, pending_precert_id, appeal_precert_id, next_Steps, pa_workflow_required }): JSX.Element => {
  const [transferCaseModal, setTransferCaseModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
  const [transferCaseNotnowModal, setTransferCaseNotnowModal] = useState<boolean>(false)
  const [precertInfoModal, setPrecertInfoModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })

  const navigate = useNavigate();
  const location = useLocation();
  const { defaultView } = useContext(AuthContext);

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0) 
    }
  }

  return (
    <div className="card">
      <div className="card-header bg-success-subtle">
        <h4 className="mb-0 text-success">
          Treatment Status
        </h4>
      </div>

      <div className="card-body">
        <RenderNextStep  
          setDataForCancelModal={setDataForCancelModal}
          showHideModalForTreatment={showHideModalForTreatment}
          updateClinicalDocumentModal={setTransferCaseModal}
          case_id={case_id}
          prescription_id={prescription_id} 
          investigated_at={investigated_at}
          active_precert_id={active_precert_id} 
          appeal_precert_id={appeal_precert_id} 
          pending_precert_id={pending_precert_id}
          next_Steps={next_Steps}
          action_Required={false}
          pa_workflow_required={pa_workflow_required}
          updateVisibilityOfTransferModal={setTransferCaseModal}
          inOneLine={true}
          refreshListing={refreshAPICall}
        />
      </div>

      <TransferCaseModal
        isModalVisible={transferCaseModal.isModalVisible}
        hideModal={() => {
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
          setTransferCaseNotnowModal(true)
        }}
        uploadClinicalInfo={() => {
          setPrecertInfoModal({
            isModalVisible: true,
            caseId: transferCaseModal.caseId,
            precertId: transferCaseModal.precertId,
          })
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
        }}
      />

      <TransferNotNowModal
        isModalVisible={transferCaseNotnowModal}
        hideModal={() => setTransferCaseNotnowModal(false)}
      />

      <UploadClinicalModal
        caseId={precertInfoModal.caseId}
        precertId={precertInfoModal.precertId}
        isModalVisible={precertInfoModal.isModalVisible}
        hideModal={(shouldFetchAgain: boolean) => {
          if (shouldFetchAgain) {
            refreshAPICall()
            redirectDecision();
          }
          setPrecertInfoModal({
            isModalVisible: false,
            caseId: 0,
            precertId: 0,
          })
        }}
      />
    </div>
  )
}

export default TreatmentStatus;
